import CityPageTemplate from "../city-template/CityPageTemplate";
import { bowieConfig } from "./data";

export default function BowiePage() {
  return <CityPageTemplate config={bowieConfig} />;
}